import { strings } from '/imports/strings';

/** Localized verb for a project-event action. */
export const eventActionLabel = (action: string): string => {
  switch (action) {
    case 'created': return strings.Created();
    case 'updated': return strings.Updated();
    case 'deleted': return strings.Deleted();
    case 'completed': return strings.Completed();
    case 'uncompleted': return strings.Reopened();
    case 'replanned': return strings.Replanned();
    case 'statusChanged': return strings.StatusChanged();
    case 'ownerChanged': return strings.OwnerChanged();
    case 'versionAdded': return strings.VersionAdded();
    case 'approved': return strings.Approved();
    case 'rejected': return strings.Rejected();
    case 'reverted': return strings.Reverted();
    case 'readyForReview': return strings.ReviewReadyForReview();
    case 'reviewApproved': return strings.ReviewApproved();
    case 'reviewDeficiency': return strings.ReviewDeficiency();
    case 'reviewReset': return strings.Reopened();
    case 'unapproved': return strings.Unapproved();
    case 'allocated': return strings.Allocated();
    default: return strings.Updated();  // 'moved' renders specially; this is only a fallback
  }
};
